import React from "react";
import PropTypes from "prop-types";
import { FormRow, ValidInput } from "@op/opds.opux";
import { Message } from "react-message-context";

const TextField = (props) => {
  const {
    fieldName,
    autocomplete,
    maxLength,
    value,
    error,
    handleOnChange,
    handleOnBlur,
    hint,
    type,
  } = props;

  const resolveError = (err) => {
    if (err.code) {
      return <Message id={`feedback.form.${fieldName}.error.${err.code}`} />;
    } else {
      return null;
    }
  };

  return (
    <FormRow
      label={<Message id={`feedback.form.${fieldName}.label`} />}
      labelId={`feedback.form.${fieldName}.label`}
      labelFor={`CFF-${fieldName}`}
      hint={hint}
      required
    >
      <ValidInput
        id={`CFF-${fieldName}`}
        name={fieldName}
        type={type || "text"}
        autoComplete={autocomplete}
        value={value}
        onChange={(_e, val) => handleOnChange(val)}
        onBlur={handleOnBlur}
        invalid={!!error}
        required
        aria-required
        maxLength={maxLength}
        error={!!error ? resolveError(error) : null}
      />
    </FormRow>
  );
};

TextField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  autocomplete: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  hint: PropTypes.element,
  type: PropTypes.string,
};

export default TextField;
